module.exports = __webpack_public_path__ + "static/media/conf-app4.efc7b3ae.png";